import React from 'react';
import PropTypes from 'prop-types';
const moment = require('moment-timezone');
import { withRouter } from 'react-router-dom';

const Strings = require('../../../../app/shared/Strings');
const TimeUtil = require('../../../../app/shared/TimeUtil');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
import SortableTable2 from '../table/SortableTable2';
import ConfirmModal from '../modal/ConfirmModal';
import WithActivityData from '../DataHOCs/WithActivityData';
import WithChannelData from '../DataHOCs/WithChannelData';
import WithProjectData from '../DataHOCs/WithProjectData';
import WithShortCourseSavesPoll from '../DataHOCs/WithShortCourseSavesPoll';
import Tooltip from '../common/Tooltip';

const propTypes = {
    history: PropTypes.object.isRequired,
    saves: PropTypes.array.isRequired,
    currentVersion: PropTypes.string.isRequired,
    shortCourseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    projectStoreState: PropTypes.shape({
        shortCourseProject: PropTypes.shape({
            user_permissions: PropTypes.object.isRequired,
        }).isRequired,
    }).isRequired,
    channelStoreState: PropTypes.shape({
        channel: PropTypes.shape({
            user_permissions: PropTypes.object.isRequired,
        }).isRequired,
    }).isRequired,
    // viewValidationForVesionFunc: PropTypes.func,
};
const defaultProps = {
    // viewValidationForVesionFunc: null,
};

class ShortCourseSavesTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            // initUsersBatchLoaded: false,
            initUsersBatchLoaded: true,
            loadUserActionId: false,
            // oldVersion: null,
            // modalState: {
            //     editOldVersion: false
            // }
        };

        // this.selectSaveVersion = this.selectSaveVersion.bind(this);
        // this.toggleEditOldVersionModal = this.toggleEditOldVersionModal.bind(this);
        // this.editOldVersion = this.editOldVersion.bind(this);
    }

    /*selectSaveVersion(actId) {
        const save = this.props.saves.find(save => save.id === actId);
        if (save && save.doc_exists) {
            if (this.props.currentVersion !== save.version) {
                this.setState({ oldVersion: save.version }, () => {
                    this.toggleEditOldVersionModal(true);
                });
            }
        }
    }*/

    /*toggleEditOldVersionModal(showBool) {
        this.setState({ modalState: { ...this.state.modalState, editOldVersion: showBool } });
    }*/

    /*editOldVersion() {
        this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}/short_course/${this.props.shortCourseId}/edit/${this.state.oldVersion}`);
    }*/

    render() {
        const self = this;
        /*const canEditShortCourse = PermissionsUtil.canEditShortCourse(
            this.props.channelStoreState.channel.user_permissions,
            this.props.projectStoreState.shortCourseProject.user_permissions
        );*/
        const canEditShortCourse = false; // disable editing specific version for now
        const guessedTimezone = moment.tz.guess();

        return (
            <div>
                <SortableTable2
                    classNameTable="margin-bottom-15 font-size-md activitySavesTable"
                    hideSearch
                    showTotal={false}
                    uniqueRowKey="id"
                    rows={this.props.saves}
                    dateFormat="YY-MM-DD HH:mm zz"
                    defaultSort={{ key:'created_at', type:'date', asc: false }}
                    topGroupHeader= {[
                        {
                            displayName: '',
                            colSpan: '1',
                            width: '14%',
                        },
                        {
                            displayName: Strings['en'].short_course.saves.THEAD_SAVE,
                            colSpan: '3',
                            width: '43%',
                        },
                        {
                            displayName: Strings['en'].short_course.saves.THEAD_PUBLISH,
                            colSpan: '3',
                            width: '43%',
                        },
                    ]}
                    columns={[
                        {
                            displayName: Strings['en'].short_course.saves.THEAD_VERSION,
                            key: 'version',
                            type: 'string',
                        },
                        {
                            displayName: Strings['en'].short_course.saves.THEAD_SAVE_USER,
                            key: 'saved_by',
                            type: 'number',
                            sortable: false,
                        },
                        {
                            displayName: Strings['en'].short_course.saves.THEAD_SAVE_DATE,
                            key: 'created_at',
                            type: 'date',
                            
                        },
                        {
                            displayName: Strings['en'].short_course.saves.THEAD_SAVE_MSG,
                            key: 'save_message',
                            type: 'string',
                            sortable: false,
                        },
                        {
                            displayName: Strings['en'].short_course.saves.THEAD_PUB_USER,
                            key: 'published_by',
                            type: 'number',
                            sortable: false,
                        },
                        {
                            displayName: Strings['en'].short_course.saves.THEAD_PUB_DATE,
                            key: 'published_on',
                            type: 'date'
                        },
                        {
                            displayName: Strings['en'].short_course.saves.THEAD_PUB_MSG,
                            key: 'publish_message',
                            type: 'string',
                            sortable: false,
                        },
                    ]}
                    displayColumnCallbacks={{
                        'version': (version, uniqueRowId) => {
                            return (
                                <span>
                                    {(canEditShortCourse) ?
                                        <button
                                            className="bare-text-button no-button-style"
                                            onClick={self.selectSaveVersion.bind(null, uniqueRowId)}
                                        >
                                            {version}
                                        </button>
                                        :
                                        version
                                    }
                                    {(version === self.props.currentVersion) &&
                                        <Tooltip
                                            id="current-version-tooltip"
                                            className="margin-left-sm mzl-cs-special-button"
                                        >
                                            {Strings['en'].short_course.saves.TABLE_CURRENT_VERSION}
                                        </Tooltip>
                                    }
                                    {/*(!!self.props.viewValidationForVesionFunc) &&
                                        <button
                                            className="bare-text-button glyph button-following"
                                            title={Strings['en'].activity.saves.TABLE_VALIDATION_RPT}
                                            aria-label={Strings['en'].activity.saves.TABLE_VALIDATION_RPT}
                                            onClick={self.props.viewValidationForVesionFunc.bind(null, version)}
                                        >
                                            <span className="fa fa-sticky-note-o" aria-hidden="true"/>
                                        </button>
                                    */}
                                </span>
                            );
                        },
                        'save_message': (message, uniqueRowId) => {
                            if (!message) return null;
                            return (
                                <Tooltip
                                    id={`save-msg-${uniqueRowId}`}
                                    className="mzl-cs-special-button"
                                    placement="top"
                                    icon="fa-info-circle"
                                >
                                        {message}
                                </Tooltip>
                            );
                        },
                    }}
                    displayColumnCallbacksRow={{
                        'saved_by': (row, uniqueRowId) => {
                            if (!row.saved_by_first_name && !row.saved_by_last_name) return null;
                            return <span>{row.saved_by_first_name} {row.saved_by_last_name}</span>
                        },
                        'published_by': (row, uniqueRowId) => {
                            if (!row.published_by_first_name && !row.published_by_last_name) return null;
                            return <span>{row.published_by_first_name} {row.published_by_last_name}</span>
                        },
                        'publish_message': (row, uniqueRowId) => {
                            return (
                                <PublishMessageTooltip
                                    id={uniqueRowId}
                                    timezone={guessedTimezone}
                                    saveData={row}
                                />
                            );
                        },
                    }}
                />
                {/*this.state.modalState.editOldVersion &&
                    <ConfirmModal
                        show
                        text={`Are you sure you wish to edit the previous version ${this.state.oldVersion}? Saving will bypass more recent changes.`}
                        closeHandler={this.toggleEditOldVersionModal.bind(this, false)}
                        confirmHandler={this.editOldVersion}
                    />
                */}
            </div>
        );
    }
}

ShortCourseSavesTable.propTypes = propTypes;
ShortCourseSavesTable.defaultProps = defaultProps;

const WrappedComponent = withRouter(WithChannelData(WithProjectData(WithShortCourseSavesPoll(ShortCourseSavesTable))));

export default WrappedComponent;

export function PublishMessageTooltip(props) {
    if (props.saveData.unpublished) {
        return (
            <Tooltip
                id={`unpub-msg-${props.id}`}
                placement="top"
                icon="fa-remove"
            >
                <div className="margin-bottom-sm">
                    {Strings['en'].short_course.IS_UNPUBLISHED}
                </div>
                <div className="margin-bottom-sm">
                    {Strings['en'].short_course.UNPUBLISHED_ON}: {TimeUtil.convertToTimeZone(props.saveData.unpublished_on, props.timezone).format("YY-MM-DD HH:mm zz")}
                </div>
                <div className="margin-bottom-sm">
                    {Strings['en'].short_course.UNPUBLISHED_BY}: <span>{props.saveData.unpublished_by_first_name} {props.saveData.unpublished_by_last_name}</span>
                </div>
                <div>
                    {Strings['en'].short_course.ORIG_PUBLISH_MSG}: {(!!props.saveData.publish_message) ?
                        <span>"{props.saveData.publish_message}"</span>
                        :
                        <span className="font-style-italic">{Strings['en'].common.NONE}</span>
                    }
                </div>
            </Tooltip>
        );
    }
    else {
        if (!props.saveData.publish_message) return null;

        return (
            <Tooltip
                id={`pub-msg-${props.id}`}
                placement="top"
                icon="fa-info-circle"
            >
                {props.saveData.publish_message}
            </Tooltip>
        );
    }
}

PublishMessageTooltip.propTypes = {
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    timezone: PropTypes.string.isRequired,
    saveData: PropTypes.shape({
        unpublished: PropTypes.bool.isRequired,
        unpublished_on: PropTypes.string,
        unpublished_by_first_name: PropTypes.string,
        unpublished_by_last_name: PropTypes.string,
        publish_message: PropTypes.string,

    }).isRequired,
};
PublishMessageTooltip.defaultProps = {};